import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { ConnectionsPage } from "~/pages/connections/connections.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/connections/",
)({
  // `connected` is set by the Connect Card redirect so the page can toast on
  // return from Fivetran OAuth; it carries the authenticated service id.
  validateSearch: z.object({ connected: z.string().optional() }),
  component: ConnectionsPage,
});
